import { fastApi } from "@/redux/api/fastApi";

const productApi = fastApi.injectEndpoints({
  endpoints: (builder) => ({
    // post product
    addProduct: builder.mutation({
      query: (payload) => ({
        url: `/brand/products?email=${payload.email}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Products"],
    }),

    // top ads
    getTopAds: builder.query<
      any,
      { productId: string; page: number; limit: number }
    >({
      query: ({ productId, page = 1, limit = 10 }) =>
        `/top_ads?product_id=${encodeURIComponent(
          productId
        )}&page=${page}&limit=${limit}`,
    }),

    // organic ads
    getOrganicAds: builder.query<
      any,
      { productId: string; page: number; limit: number }
    >({
      query: ({ productId, page = 1, limit = 10 }) =>
        `/competitor_organic?product_id=${encodeURIComponent(
          productId
        )}&page=${page}&limit=${limit}`,
    }),

    // get competitors
    getCompetitors: builder.query<any, { productId: string }>({
      query: ({ productId }) =>
        `/competitors?product_id=${encodeURIComponent(productId)}`,
    }),

    // Get persona
    getPersona: builder.query<any, { productId: string }>({
      query: ({ productId }) =>
        `/persona?product_id=${encodeURIComponent(productId)}`,
    }),

    // Get competitor videos by brand
    getCompetitorVideosByBrand: builder.query<
      any,
      {
        comp_name: string;
        productId: string;
        page: number;
        limit: number;
      }
    >({
      query: ({ comp_name, productId, page = 1, limit = 10 }) =>
        `/competitor_videos_by_brand?comp_name=${encodeURIComponent(
          comp_name
        )}&product_id=${encodeURIComponent(
          productId
        )}&page=${page}&limit=${limit}`,
    }),

    // Get competitor videos
    getCompetitorVideos: builder.query<
      any,
      { productId: string; page: number; limit: number }
    >({
      query: ({ productId, page = 1, limit = 10 }) =>
        `/competitor_ads?product_id=${encodeURIComponent(
          productId
        )}&page=${page}&limit=${limit}`,
    }),

    // get videos by persona
    getVideosByPersona: builder.query<
      any,
      { productId: string; persona: string; page: number; limit: number }
    >({
      query: ({ productId, persona, page = 1, limit = 10 }) =>
        `/get_videos_by_persona?product_id=${encodeURIComponent(
          productId
        )}&persona=${persona}&page=${page}&limit=${limit}`,
    }),

    // get brand videos
    getBrandVideos: builder.query<any, { productId: string }>({
      query: ({ productId }) =>
        `/brand_videos?product_id=${encodeURIComponent(productId)}`,
    }),

    //add manual competitor
    addCompetitor: builder.mutation({
      query: (payload) => ({
        url: `manual_competitor/add`,
        method: "POST",
        body: payload,
      }),
    }),

    // get Recommendation structure
    getRecommendation: builder.query<
      any,
      { productId: string; persona: string }
    >({
      query: ({ productId, persona }) =>
        `/recommendation?product_id=${encodeURIComponent(
          productId
        )}&persona_name=${encodeURIComponent(persona)}`,
    }),

    // get insights
    getInsights: builder.query<any, { productId: string }>({
      query: ({ productId }) =>
        `/get_insights?product_id=${encodeURIComponent(productId)}`,
    }),

    // get generated scripts
    getGeneratedScripts: builder.query<
      any,
      {
        brand: string;
        product: string;
        productId: string;
        selected_persona: string;
        country: string;
        id: string;
      }
    >({
      query: ({ brand, product, selected_persona, id, country, productId }) =>
        `/generate_script?product_id=${productId}&brand=${encodeURIComponent(
          brand
        )}&product=${encodeURIComponent(
          product
        )}&selected_persona=${encodeURIComponent(
          selected_persona
        )}&id=${encodeURIComponent(id)}&country=${encodeURIComponent(country)}`,
    }),

    // get market scripts
    getMarketScript: builder.query<
      any,
      {
        productId: string;
        selected_persona: string;
      }
    >({
      query: ({ productId, selected_persona }) =>
        `/market_script?product_id=${encodeURIComponent(
          productId
        )}&selected_persona=${encodeURIComponent(selected_persona)}`,
    }),

    // get reddit comments
    getRedditComments: builder.query({
      query: ({ productId }) => ({
        url: `reddit-comments/all-comments`,
        params: {
          product_id: productId,
        },
      }),
    }),

    // add and get generate video script
    addGetGenerateVideoScript: builder.mutation({
      query: (payload) => ({
        url: `video-scripts/generate`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useAddProductMutation,
  useGetTopAdsQuery,
  useGetOrganicAdsQuery,
  useGetCompetitorsQuery,
  useGetCompetitorVideosQuery,
  useGetCompetitorVideosByBrandQuery,
  useAddCompetitorMutation,
  useGetBrandVideosQuery,
  useGetVideosByPersonaQuery,
  useGetRecommendationQuery,
  useGetPersonaQuery,
  useGetInsightsQuery,
  useGetGeneratedScriptsQuery,
  useGetMarketScriptQuery,
  useGetRedditCommentsQuery,
  useAddGetGenerateVideoScriptMutation,
} = productApi;
